(function () {
  var CACHE_KEY = 'glozin__color-families'; // shared with collection-sidebar
  var SWATCH_SELECTOR = '.product__color-swatches--js';
  var SCOPE_SELECTOR =
    'variant-radios-detail, variant-group-detail, variant-radios-single, variant-radios-bundle';

  function normalize(name) {
    return String(name || '')
      .toLowerCase()
      .trim()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  // name(normalized) -> hex, populated from the API/cache.
  window.colorHexByName = window.colorHexByName || {};

  function buildMap(families) {
    if (!Array.isArray(families)) return false;
    var added = false;
    families.forEach(function (family) {
      (family.colors || []).forEach(function (c) {
        if (c && c.label && c.hex) {
          window.colorHexByName[normalize(c.label)] = c.hex;
          added = true;
        }
      });
    });
    return added;
  }

  function swatchName(el) {
    return el.getAttribute('data-value') || el.getAttribute('data-color') || '';
  }

  function fillSwatch(el) {
    if (!el || !el.closest || !el.closest(SCOPE_SELECTOR)) return;
    var resolved = el.getAttribute('data-option-swatch-value');
    if (resolved && resolved.length) return;

    var hex = window.colorHexByName[normalize(swatchName(el))];
    if (!hex) return;

    el.style.setProperty('--swatch--background', hex);
    el.setAttribute('data-option-swatch-value', hex);
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SWATCH_SELECTOR).forEach(fillSwatch);
  }
  window.applyColorHexSwatches = applyAll;

  function observe() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SWATCH_SELECTOR)) {
            fillSwatch(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll(SWATCH_SELECTOR).forEach(fillSwatch);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && buildMap(cached.families)) applyAll(document);
    } catch (e) {}

    observe();

    var base = window.API_ENDPOINT;
    var key = window.API_KEY;
    if (!base || !key) return;

    fetch(base + '/shopify/colors', {
      headers: { 'x-api-key': key, 'ngrok-skip-browser-warning': 'true' },
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (res) {
        var families = res && res.data && res.data.families;
        if (!families) return;
        if (buildMap(families)) applyAll(document);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ families: families }));
        } catch (e) {}
      })
      .catch(function () { /* keep cached colors */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
